import { GetBaseArgs } from "@/lib/baseListOptions";

/**
 * @function ApiClient#GetRoutines
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} listOptions
 * @param {any} options = {}
 */
export async function GetRoutines(cid, listOptions, options = {}) {
  const args = GetBaseArgs(listOptions);
  const url = Object.keys(args).reduce((acc, value, index) => {
    return acc + (index === 0 ? "?" : "&") + value + args[value];
  }, `/community/${cid}/maintenance/routines`);
  return await this._get(url, options);
}

/**
 * @function ApiClient#AddRoutine
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} payload
 * @param {any} options = {}
 */
export async function AddRoutine(cid, payload, options = {}) {
  return await this._post(`/community/${cid}/maintenance/routine`, payload, options);
}

/**
 * @function ApiClient#EditRoutine
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} payload
 * @param {any} options = {}
 */
export async function EditRoutine(cid, id, payload, options = {}) {
  return await this._put(`/community/${cid}/maintenance/routine/${id || ""}`, payload, options);
}

/**
 * @function ApiClient#DeleteRoutine
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteRoutine(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/maintenance/routine/${id || ""}`, options);
}

/**
 * @function ApiClient#GetRoutineProcess
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetRoutineProcess(cid, id, options = {}) {
  return await this._get(`/community/${cid}/maintenance/routine/${id || ""}/process/report`, options);
}

/**
 * @function ApiClient#AddProcessRoutine
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} payload
 * @param {any} files
 * @param {any} options = {}
 */
export async function AddProcessRoutine(cid, id, payload, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(payload));

  if (Array.isArray(files)) {
    files.forEach((file) => formData.append("Image", file));
  }
  return await this._post(`/community/${cid}/maintenance/routine/${id || ""}/process`, formData, options);
}

/**
 * @function ApiClient#EditProcessRoutine
 * @this {ApiClient}
 * @param {any} cid = ""
 * @param {any} routineId = ""
 * @param {any} reportId = ""
 * @param {any} payload
 * @param {any} files
 * @param {any} options = {}
 */
export async function EditProcessRoutine(cid = "", routineId = "", reportId = "", payload, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(payload));

  if (Array.isArray(files)) {
    files.forEach((file) => formData.append("Image", file));
  }
  return await this._put(`/community/${cid}/maintenance/routine/${routineId}/process/${reportId}`, formData, options);
}
